import React from 'react';
import { AnchorLink } from 'react-anchor-navigation';
import { Props } from './interfaces';

const LinkHashMenu = ({ menu, onClickLink }: Props) => {
  const { link, text, mark } = menu;
  return (
    <AnchorLink
      href={link}
      activeClassName="selected"
      className={`menu-top__item-menu`}
      onClick={onClickLink ? onClickLink : () => {}}
    >
      <p className={mark ? 'menu-top__link-with-mark' : ''} dangerouslySetInnerHTML={{ __html: text }}></p>
    </AnchorLink>
  );
};

export default LinkHashMenu;
